// components/BannerAdmin.jsx - Full Version with DB Save & Load
import React, { useState, useEffect } from 'react';
import Banner from '../components/Banner';
import axios from 'axios';
import config from '../config/config';

const BannerAdmin = ({ config: initialConfig = {}, slug='', onSave, onClose }) => {
  const [bannerpreset, setPreset] = useState('full-width');
  const [autoPlay, setAutoPlay] = useState(true);
  const [interval, setInterval] = useState(5000);
  const [confetti, setConfetti] = useState({
    enabled: true,
    trigger: 'onLoad',
    particleCount: 100,
    spread: 70,
    originY: 0.6,
    colors: '#ff718b,#fdba74,#a78bfa,#72ddf7',
    ticks: 200,
    gravity: 0.8,
    decay: 0.94,
    scalar: 1,
    shapes: 'square,circle',
  });

  const [slides, setSlides] = useState([]);
  const [leftPanel, setLeftPanel] = useState({
    title: "Best Sellers",
    subtitle: "Featured",
    description: "Explore our most loved products",
    ctaText: "View All",
    ctaLink: "/",
    bgClass: "bg-gray-900",
    image: null,
    imageOverlayColor: "black",
    imageOverlayOpacity: 20,
    contentPadding: "p-8",
    titleStyle: { color: '#ffffff', fontSize: 'text-2xl', fontWeight: 'font-light', fontFamily: 'font-sans' },
    subtitleStyle: { color: '#ffffff', fontSize: 'text-sm', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    descriptionStyle: { color: '#ffffff', fontSize: 'text-base', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    ctaStyle: { bgColor: 'bg-white', textColor: 'text-gray-900' },
  });
  const [rightTopPanel, setRightTopPanel] = useState({
    title: "Up to 40% Off",
    subtitle: "Sale",
    description: "",
    ctaText: "Shop Sale →",
    ctaLink: "/",
    bgClass: "bg-gradient-to-br from-pink-50 to-rose-100",
    image: null,
    imageOverlayColor: "black",
    imageOverlayOpacity: 20,
    contentPadding: "p-8",
    titleStyle: { color: '#111827', fontSize: 'text-xl', fontWeight: 'font-medium', fontFamily: 'font-sans' },
    subtitleStyle: { color: '#111827', fontSize: 'text-sm', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    descriptionStyle: { color: '#111827', fontSize: 'text-base', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    ctaStyle: { bgColor: '', textColor: 'text-gray-900 underline' },
  });
  const [rightBottomPanel, setRightBottomPanel] = useState({
    title: "Fresh Arrivals",
    subtitle: "New",
    description: "",
    ctaText: "Discover →",
    ctaLink: "/",
    bgClass: "bg-gradient-to-br from-violet-50 to-purple-100",
    image: null,
    imageOverlayColor: "black",
    imageOverlayOpacity: 20,
    contentPadding: "p-8",
    titleStyle: { color: '#111827', fontSize: 'text-xl', fontWeight: 'font-medium', fontFamily: 'font-sans' },
    subtitleStyle: { color: '#111827', fontSize: 'text-sm', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    descriptionStyle: { color: '#111827', fontSize: 'text-base', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    ctaStyle: { bgColor: '', textColor: 'text-gray-900 underline' },
  });
  const [asymmetricSidebar, setAsymmetricSidebar] = useState({
    top: {
      title: "Member Exclusive",
      subtitle: "Exclusive",
      description: "Join now for early access",
      ctaText: "Sign Up",
      ctaLink: "/",
      bgClass: "bg-gray-900",
      image: null,
      imageOverlayColor: "black",
      imageOverlayOpacity: 20,
      contentPadding: "p-8",
      titleStyle: { color: '#ffffff', fontSize: 'text-xl', fontWeight: 'font-medium', fontFamily: 'font-sans' },
      subtitleStyle: { color: '#ffffff', fontSize: 'text-sm', fontWeight: 'font-normal', fontFamily: 'font-sans' },
      descriptionStyle: { color: '#ffffff', fontSize: 'text-base', fontWeight: 'font-normal', fontFamily: 'font-sans' },
      ctaStyle: { bgColor: 'bg-white', textColor: 'text-gray-900' },
    },
    bottom: {
      title: "Flash Deal",
      subtitle: "Limited",
      description: "24 hours only",
      ctaText: "Shop Now",
      ctaLink: "/",
      bgClass: "bg-gradient-to-br from-amber-50 to-yellow-100",
      image: null,
      imageOverlayColor: "black",
      imageOverlayOpacity: 20,
      contentPadding: "p-8",
      titleStyle: { color: '#111827', fontSize: 'text-xl', fontWeight: 'font-medium', fontFamily: 'font-sans' },
      subtitleStyle: { color: '#111827', fontSize: 'text-sm', fontWeight: 'font-normal', fontFamily: 'font-sans' },
      descriptionStyle: { color: '#111827', fontSize: 'text-base', fontWeight: 'font-normal', fontFamily: 'font-sans' },
      ctaStyle: { bgColor: 'bg-gray-900', textColor: 'text-white' },
    },
  });

  const [devMode, setDevMode] = useState(false);
  const [container, setContainer] = useState({
    padding: 'p-4 md:p-10',
    margin: '',
    borderRadius: 'rounded-lg',
    boxShadow: '',
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const token = localStorage.getItem("token");

  // Load from DB on mount
  useEffect(() => {
    const loadSettings = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

        let response;
        const isDuplicate = slug.includes('-');

        if (isDuplicate) {
          response = await axios.get(
            `${config.API_URL}/api/pullCustomSettings/${slug}`,
            { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
          );
          const dbData = response.data.customSettings || {};
          applyDbData(dbData);
        } else {
          response = await axios.get(
            config.API_URL + '/api/pullBannerSettings',
            { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
          );
          const dbData = response.data.bannerSettings || {};
          applyDbData(dbData);
        }
      } catch (error) {
        console.error("Failed to load banner settings:", error);
        alert("Using default settings (failed to load from DB)");
      } finally {
        setLoading(false);
      }
    };

  const applyDbData = (dbData) => {
  // Generic deep merge helper — works for slides, left, rightTop, rightBottom, asymmetric top/bottom
  const deepMergePanel = (defaultPanel, dbPanel = {}) => ({
    ...defaultPanel,
    ...dbPanel,
    titleStyle:       { ...defaultPanel.titleStyle,       ...(dbPanel?.titleStyle       || {}) },
    subtitleStyle:    { ...defaultPanel.subtitleStyle,    ...(dbPanel?.subtitleStyle    || {}) },
    descriptionStyle: { ...defaultPanel.descriptionStyle, ...(dbPanel?.descriptionStyle || {}) },
    ctaStyle:         { ...defaultPanel.ctaStyle,         ...(dbPanel?.ctaStyle         || {}) },
    // You can add more nested fields here in future (e.g. overlayStyle, imageStyle)
  });

  // Default slide (used as fallback template)
  const defaultSlide = {
    id: Date.now(),
    title: "New Slide",
    subtitle: "Subtitle",
    description: "Your description here",
    ctaText: "Shop Now",
    ctaLink: "/",
    background: "bg-gradient-to-br from-gray-50 to-gray-200",
    image: null,
    imageOverlayColor: "black",
    imageOverlayOpacity: 20,
    contentPadding: "p-10",
    triggerConfetti: false,
    titleStyle:     { color: '#111827', fontSize: 'text-6xl', fontWeight: 'font-light', fontFamily: 'font-sans' },
    subtitleStyle:  { color: '#4b5563', fontSize: 'text-base', fontWeight: 'font-light', fontFamily: 'font-sans' },
    descriptionStyle: { color: '#374151', fontSize: 'text-lg', fontWeight: 'font-normal', fontFamily: 'font-sans' },
    ctaStyle:       { bgColor: 'bg-gray-900', textColor: 'text-white' },
  };

  // Slides (full-width)
  setSlides(
    dbData.slides?.map(dbSlide => deepMergePanel(defaultSlide, dbSlide)) || slides
  );

  // Three-column panels
  setLeftPanel(deepMergePanel(leftPanel, dbData.leftPanel));
  setRightTopPanel(deepMergePanel(rightTopPanel, dbData.rightTopPanel));
  setRightBottomPanel(deepMergePanel(rightBottomPanel, dbData.rightBottomPanel));

  // Asymmetric panels
  setAsymmetricSidebar({
    top:    deepMergePanel(asymmetricSidebar.top,    dbData.asymmetricSidebar?.top),
    bottom: deepMergePanel(asymmetricSidebar.bottom, dbData.asymmetricSidebar?.bottom),
  });

  // Simple fields
  setPreset(dbData.bannerpreset || bannerpreset);
  setAutoPlay(dbData.autoPlay ?? autoPlay);
  setInterval(dbData.interval || interval);
  setConfetti(dbData.confetti || confetti);
  setDevMode(dbData.devMode || devMode);
  setContainer(dbData.customStyles?.container || container);
};

    loadSettings();
  }, [token, slug]);

  // Current config for preview & save
  const currentConfig = {
    bannerpreset,
    autoPlay,
    interval,
    confetti,
    slides,
    leftPanel,
    rightTopPanel,
    rightBottomPanel,
    asymmetricSidebar,
    devMode,
    customStyles: { container },
  };

  // Save to DB
  const saveBannerSettings = async () => {
    try {
      setSaving(true);
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrfToken = document.cookie
        .split('; ')
        .find(row => row.startsWith('XSRF-TOKEN='))
        ?.split('=')[1];

      const payload = {
        settings: currentConfig
      };

      const response = await axios.post(
        config.API_URL + "/api/saveBannerSettings/"+slug,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "X-XSRF-TOKEN": decodeURIComponent(xsrfToken || ''),
          },
          withCredentials: true,
        }
      );

      if (response.data.status === 1) {
        alert("Banner settings saved successfully! 🎉");
      } else {
        alert("Save failed: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Save error:", error);
      alert("Failed to save. Check console/network tab.");
    } finally {
      setSaving(false);
    }
  };

  const [fullScreenPreview, setFullScreenPreview] = useState(false);

  const updateConfetti = (field, value) => setConfetti({ ...confetti, [field]: value });

  const addSlide = () => {
    setSlides([
      ...slides,
      {
        id: Date.now(),
        title: "New Slide",
        subtitle: "Subtitle",
        description: "Your description here",
        ctaText: "Shop Now",
        ctaLink: "/",
        background: "bg-gradient-to-br from-gray-50 to-gray-200",
        image: null,
        imageOverlayColor: "black",
        imageOverlayOpacity: 20,
        contentPadding: "p-10",
        triggerConfetti: false,
        titleStyle: { color: '#111827', fontSize: 'text-6xl', fontWeight: 'font-light', fontFamily: 'font-sans' },
        subtitleStyle: { color: '#4b5563', fontSize: 'text-base', fontWeight: 'font-light', fontFamily: 'font-sans' },
        descriptionStyle: { color: '#374151', fontSize: 'text-lg', fontWeight: 'font-normal', fontFamily: 'font-sans' },
        ctaStyle: { bgColor: 'bg-gray-900', textColor: 'text-white' },
      },
    ]);
  };

  const updateSlide = (id, field, value) => {
    setSlides(slides.map((s) => (s.id === id ? { ...s, [field]: value } : s)));
  };

  const updateSlideStyle = (id, element, property, value) => {
    setSlides(slides.map((s) =>
      s.id === id ? { ...s, [element]: { ...s[element], [property]: value } } : s
    ));
  };

  const removeSlide = (id) => setSlides(slides.filter((s) => s.id !== id));

  const moveSlide = (id, direction) => {
    const index = slides.findIndex((s) => s.id === id);
    if ((direction === -1 && index === 0) || (direction === 1 && index === slides.length - 1)) return;
    const newSlides = [...slides];
    [newSlides[index], newSlides[index + direction]] = [newSlides[index + direction], newSlides[index]];
    setSlides(newSlides);
  };

  const handleImageUpload = (id, e, setter = setSlides, isPanel = false, panelKey) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (isPanel) {
          setter(prev => ({ ...prev, [panelKey]: { ...prev[panelKey], image: reader.result } }));
        } else {
          setter(slides.map((s) => (s.id === id ? { ...s, image: reader.result } : s)));
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const updatePanel = (setter, field, value) => setter(prev => ({ ...prev, [field]: value }));

  const updatePanelStyle = (setter, element, property, value) => {
    setter(prev => ({ ...prev, [element]: { ...prev[element], [property]: value } }));
  };

  const updateAsymmetric = (section, field, value) => {
    setAsymmetricSidebar(prev => ({
      ...prev,
      [section]: { ...prev[section], [field]: value }
    }));
  };

  const updateAsymmetricStyle = (section, element, property, value) => {
    setAsymmetricSidebar(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [element]: { ...prev[section][element], [property]: value }
      }
    }));
  };

  const previewConfig = currentConfig;

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <p className="text-xl text-gray-600">Loading banner settings...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex">
      {/* Main Preview */}
      <div className="flex-1 relative">
        <div className="absolute inset-0 flex flex-col">
          <div className="bg-white border-b px-6 py-4 flex justify-between items-center shadow-sm z-10">
            <h1 className="text-2xl font-bold text-gray-900">Banner Hero Editor</h1>
            <button
              onClick={() => setFullScreenPreview(true)}
              className="bg-blue-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-blue-700 shadow transform hover:scale-105 transition"
            >
              Full Screen Preview
            </button>
          </div>
          <div className="flex-1 overflow-auto bg-gradient-to-b from-gray-50 to-gray-100">
            <div className={container.padding + ' ' + container.margin}>
              <div className={`mx-auto ${container.borderRadius} ${container.boxShadow} overflow-hidden`}>
                <Banner config={currentConfig} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Settings Drawer */}
      <div className="w-96 bg-white border-l border-gray-200 overflow-y-auto shadow-2xl relative">
        <div className="p-6 space-y-6">
          <h2 className="text-xl font-semibold text-gray-900">Settings</h2>

          <details open>
            <summary className="font-medium cursor-pointer">Layout Preset</summary>
            <div className="grid gap-3 mt-2">
              {['full-width', 'three-column', 'asymmetric'].map((p) => (
                <button
                  key={p}
                  onClick={() => setPreset(p)}
                  className={`p-4 border rounded-lg text-left transform hover:scale-105 transition ${bannerpreset === p ? 'border-blue-500 bg-blue-50' : 'border-gray-200'}`}
                >
                  <span className="font-medium capitalize">{p.replace('-', ' ')}</span>
                </button>
              ))}
            </div>
          </details>

          <details open>
            <summary className="font-medium cursor-pointer">Auto Play</summary>
            <div className="mt-2 space-y-3">
              <div className="flex justify-between items-center">
                <h3 className="font-medium text-gray-900">Auto Play</h3>
                <button
                  onClick={() => setAutoPlay(!autoPlay)}
                  className={`relative inline-flex h-6 w-11 rounded-full transition transform hover:scale-110 ${autoPlay ? 'bg-blue-600' : 'bg-gray-300'}`}
                >
                  <span className={`inline-block h-4 w-4 rounded-full bg-white transition ${autoPlay ? 'translate-x-6' : 'translate-x-1'}`} />
                </button>
              </div>
              {autoPlay && (
                <input
                  type="number"
                  value={interval / 1000}
                  onChange={(e) => setInterval(parseInt(e.target.value || '5') * 1000)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  min="1"
                  placeholder="Seconds"
                />
              )}
            </div>
          </details>

          <details open>
            <summary className="font-medium cursor-pointer">Confetti Effects 🎉</summary>
            <div className="mt-2 space-y-3">
              <div className="flex justify-between items-center">
                <h3 className="font-medium text-gray-900">Enabled</h3>
                <button
                  onClick={() => updateConfetti('enabled', !confetti.enabled)}
                  className={`relative inline-flex h-6 w-11 rounded-full transition transform hover:scale-110 ${confetti.enabled ? 'bg-green-600' : 'bg-gray-300'}`}
                >
                  <span className={`inline-block h-4 w-4 rounded-full bg-white transition ${confetti.enabled ? 'translate-x-6' : 'translate-x-1'}`} />
                </button>
              </div>
              {confetti.enabled && (
                <div className="space-y-3">
                  <select
                    value={confetti.trigger}
                    onChange={(e) => updateConfetti('trigger', e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                  >
                    <option value="onLoad">On Page Load</option>
                    <option value="onSlideChange">On Slide Change</option>
                    <option value="onCTA">On CTA Click</option>
                  </select>
                  <input
                    type="number"
                    value={confetti.particleCount}
                    onChange={(e) => updateConfetti('particleCount', parseInt(e.target.value) || 100)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Particles"
                  />
                  <input
                    type="number"
                    value={confetti.spread}
                    onChange={(e) => updateConfetti('spread', parseInt(e.target.value) || 70)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="Spread"
                  />
                  <input
                    value={confetti.colors}
                    onChange={(e) => updateConfetti('colors', e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                    placeholder="#ff0000, #00ff00, #0000ff"
                  />
                </div>
              )}
            </div>
          </details>

          <details open>
            <summary className="font-medium cursor-pointer">Slides ({slides.length})</summary>
            <div className="mt-2 space-y-4">
              <button onClick={addSlide} className="text-blue-600 text-sm font-medium transform hover:scale-105 transition">+ Add Slide</button>
              {slides.map((slide, idx) => (
                <details key={slide.id} open className="border rounded-lg p-4 space-y-4 bg-gray-50">
                  <summary className="font-medium cursor-pointer flex justify-between">
                    Slide {idx + 1}
                    <div className="flex gap-1">
                      <button onClick={() => moveSlide(slide.id, -1)} disabled={idx === 0} className="p-1 hover:bg-gray-200 rounded disabled:opacity-50 transform hover:scale-110 transition">↑</button>
                      <button onClick={() => moveSlide(slide.id, 1)} disabled={idx === slides.length - 1} className="p-1 hover:bg-gray-200 rounded disabled:opacity-50 transform hover:scale-110 transition">↓</button>
                      <button onClick={() => removeSlide(slide.id)} className="p-1 text-red-600 hover:bg-red-50 rounded transform hover:scale-110 transition">×</button>
                    </div>
                  </summary>

                  <input value={slide.title} onChange={(e) => updateSlide(slide.id, 'title', e.target.value)} className="w-full px-3 py-2 border rounded-md font-semibold" placeholder="Title" />
                  <input value={slide.subtitle} onChange={(e) => updateSlide(slide.id, 'subtitle', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Subtitle" />
                  <textarea value={slide.description} onChange={(e) => updateSlide(slide.id, 'description', e.target.value)} className="w-full px-3 py-2 border rounded-md h-20" placeholder="Description" />

                  <div className="grid grid-cols-2 gap-3">
                    <input value={slide.ctaText} onChange={(e) => updateSlide(slide.id, 'ctaText', e.target.value)} className="px-3 py-2 border rounded-md" placeholder="CTA Text" />
                    <input value={slide.ctaLink} onChange={(e) => updateSlide(slide.id, 'ctaLink', e.target.value)} className="px-3 py-2 border rounded-md" placeholder="Link" />
                  </div>

                  <div className="space-y-3 pt-3 border-t">
                    <h4 className="font-medium text-sm">Title Styling</h4>
                    <input type="color" value={slide.titleStyle.color} onChange={(e) => updateSlideStyle(slide.id, 'titleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                    <select value={slide.titleStyle.fontSize} onChange={(e) => updateSlideStyle(slide.id, 'titleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="text-4xl">4XL</option>
                      <option value="text-5xl">5XL</option>
                      <option value="text-6xl">6XL</option>
                      <option value="text-7xl">7XL</option>
                    </select>
                    <select value={slide.titleStyle.fontWeight} onChange={(e) => updateSlideStyle(slide.id, 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="font-thin">Thin</option>
                      <option value="font-light">Light</option>
                      <option value="font-normal">Normal</option>
                      <option value="font-medium">Medium</option>
                      <option value="font-semibold">Semibold</option>
                      <option value="font-bold">Bold</option>
                    </select>
                    <select value={slide.titleStyle.fontFamily} onChange={(e) => updateSlideStyle(slide.id, 'titleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="font-sans">Sans</option>
                      <option value="font-serif">Serif</option>
                      <option value="font-mono">Mono</option>
                    </select>
                  </div>

                  <div className="space-y-3">
                    <h4 className="font-medium text-sm">Subtitle Styling</h4>
                    <input type="color" value={slide.subtitleStyle.color} onChange={(e) => updateSlideStyle(slide.id, 'subtitleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                    <select value={slide.subtitleStyle.fontSize} onChange={(e) => updateSlideStyle(slide.id, 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="text-sm">Small</option>
                      <option value="text-base">Base</option>
                      <option value="text-lg">Large</option>
                      <option value="text-xl">XL</option>
                    </select>
                    <select value={slide.subtitleStyle.fontWeight} onChange={(e) => updateSlideStyle(slide.id, 'subtitleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="font-light">Light</option>
                      <option value="font-normal">Normal</option>
                      <option value="font-medium">Medium</option>
                      <option value="font-semibold">Semibold</option>
                    </select>
                    <select value={slide.subtitleStyle.fontFamily} onChange={(e) => updateSlideStyle(slide.id, 'subtitleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="font-sans">Sans</option>
                      <option value="font-serif">Serif</option>
                      <option value="font-mono">Mono</option>
                    </select>
                  </div>

                  <div className="space-y-3">
                    <h4 className="font-medium text-sm">Description Styling</h4>
                    <input type="color" value={slide.descriptionStyle.color} onChange={(e) => updateSlideStyle(slide.id, 'descriptionStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                    <select value={slide.descriptionStyle.fontSize} onChange={(e) => updateSlideStyle(slide.id, 'descriptionStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="text-base">Base</option>
                      <option value="text-lg">Large</option>
                      <option value="text-xl">XL</option>
                    </select>
                    <select value={slide.descriptionStyle.fontWeight} onChange={(e) => updateSlideStyle(slide.id, 'descriptionStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="font-normal">Normal</option>
                      <option value="font-medium">Medium</option>
                    </select>
                    <select value={slide.descriptionStyle.fontFamily} onChange={(e) => updateSlideStyle(slide.id, 'descriptionStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                      <option value="font-sans">Sans</option>
                      <option value="font-serif">Serif</option>
                      <option value="font-mono">Mono</option>
                    </select>
                  </div>

                  <div className="space-y-3">
                    <h4 className="font-medium text-sm">CTA Button</h4>
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-xs">Background</label>
                        <input type="text" value={slide.ctaStyle.bgColor} onChange={(e) => updateSlideStyle(slide.id, 'ctaStyle', 'bgColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="bg-gray-900" />
                      </div>
                      <div>
                        <label className="text-xs">Text</label>
                        <input type="text" value={slide.ctaStyle.textColor} onChange={(e) => updateSlideStyle(slide.id, 'ctaStyle', 'textColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="text-white" />
                      </div>
                    </div>
                  </div>

                  <div className="space-y-3">
                    <h4 className="font-medium text-sm">Content Padding</h4>
                    <input value={slide.contentPadding} onChange={(e) => updateSlide(slide.id, 'contentPadding', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="p-10" />
                  </div>

                  <div>
                    <label className="block text-sm font-medium mb-1">Background Image</label>
                    <input type="file" accept="image/*" onChange={(e) => handleImageUpload(slide.id, e)} className="text-sm" />
                    {slide.image && <img src={slide.image} alt="preview" className="mt-3 h-40 w-full object-cover rounded" />}
                  </div>
                  <input
                    value={slide.background}
                    onChange={(e) => updateSlide(slide.id, 'background', e.target.value)}
                    className="w-full px-3 py-2 border rounded-md text-xs"
                    placeholder="Gradient or bg class e.g. bg-gradient-to-br from-gray-50/80 to-gray-200/50"
                  />
                  <div className="space-y-3">
                    <h4 className="font-medium text-sm">Image Overlay</h4>
                    <input type="text" value={slide.imageOverlayColor} onChange={(e) => updateSlide(slide.id, 'imageOverlayColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="black" />
                    <input type="number" value={slide.imageOverlayOpacity} onChange={(e) => updateSlide(slide.id, 'imageOverlayOpacity', parseInt(e.target.value) || 20)} min="0" max="100" className="w-full px-3 py-2 border rounded-md" placeholder="Opacity 0-100" />
                  </div>

                  <div className="flex items-center gap-2">
                    <input type="checkbox" checked={slide.triggerConfetti} onChange={(e) => updateSlide(slide.id, 'triggerConfetti', e.target.checked)} />
                    <label className="text-sm">Trigger Confetti</label>
                  </div>
                </details>
              ))}
            </div>
          </details>

          {(bannerpreset === 'three-column' || bannerpreset === 'asymmetric') && (
            <details open className="pt-6 border-t">
              <summary className="font-semibold text-lg cursor-pointer">Side Panels</summary>
              <div className="mt-2 space-y-6">
                {bannerpreset === 'three-column' && (
                  <details open>
                    <summary className="font-medium cursor-pointer">Left Panel</summary>
                    <div className="mt-2 space-y-3">
                      <input value={leftPanel.title} onChange={(e) => updatePanel(setLeftPanel, 'title', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Title" />
                      <input value={leftPanel.subtitle} onChange={(e) => updatePanel(setLeftPanel, 'subtitle', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Subtitle" />
                      <textarea value={leftPanel.description} onChange={(e) => updatePanel(setLeftPanel, 'description', e.target.value)} className="w-full px-3 py-2 border rounded-md h-20" placeholder="Description" />
                      <input value={leftPanel.ctaText} onChange={(e) => updatePanel(setLeftPanel, 'ctaText', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="CTA Text" />
                      <input value={leftPanel.ctaLink} onChange={(e) => updatePanel(setLeftPanel, 'ctaLink', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="CTA Link" />
                      <input value={leftPanel.bgClass} onChange={(e) => updatePanel(setLeftPanel, 'bgClass', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Bg class or gradient" />
                      <div>
                        <label className="block text-sm font-medium mb-1">Background Image</label>
                        <input type="file" accept="image/*" onChange={(e) => handleImageUpload(null, e, setLeftPanel, true, null)} className="text-sm" />
                        {leftPanel.image && <img src={leftPanel.image} alt="preview" className="mt-3 h-40 w-full object-cover rounded" />}
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-sm">Image Overlay</h4>
                        <input type="text" value={leftPanel.imageOverlayColor} onChange={(e) => updatePanel(setLeftPanel, 'imageOverlayColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="black" />
                        <input type="number" value={leftPanel.imageOverlayOpacity} onChange={(e) => updatePanel(setLeftPanel, 'imageOverlayOpacity', parseInt(e.target.value) || 20)} min="0" max="100" className="w-full px-3 py-2 border rounded-md" placeholder="Opacity 0-100" />
                      </div>
                      <input value={leftPanel.contentPadding} onChange={(e) => updatePanel(setLeftPanel, 'contentPadding', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Content Padding e.g. p-8" />
                      <div className="space-y-3">
                        <h4 className="font-medium text-sm">Title Styling</h4>
                        <input type="color" value={leftPanel.titleStyle.color} onChange={(e) => updatePanelStyle(setLeftPanel, 'titleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                        <select value={leftPanel.titleStyle.fontSize} onChange={(e) => updatePanelStyle(setLeftPanel, 'titleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="text-xl">XL</option>
                          <option value="text-2xl">2XL</option>
                          <option value="text-3xl">3XL</option>
                        </select>
                        <select value={leftPanel.titleStyle.fontWeight} onChange={(e) => updatePanelStyle(setLeftPanel, 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="font-light">Light</option>
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={leftPanel.titleStyle.fontFamily} onChange={(e) => updatePanelStyle(setLeftPanel, 'titleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      {/* Similar for subtitle, description, cta */}
                      <div className="space-y-3">
                        <h4 className="font-medium text-sm">Subtitle Styling</h4>
                        <input type="color" value={leftPanel.subtitleStyle.color} onChange={(e) => updatePanelStyle(setLeftPanel, 'subtitleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                        <select value={leftPanel.subtitleStyle.fontSize} onChange={(e) => updatePanelStyle(setLeftPanel, 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="text-sm">Small</option>
                          <option value="text-base">Base</option>
                        </select>
                        <select value={leftPanel.subtitleStyle.fontWeight} onChange={(e) => updatePanelStyle(setLeftPanel, 'subtitleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={leftPanel.subtitleStyle.fontFamily} onChange={(e) => updatePanelStyle(setLeftPanel, 'subtitleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-sm">Description Styling</h4>
                        <input type="color" value={leftPanel.descriptionStyle.color} onChange={(e) => updatePanelStyle(setLeftPanel, 'descriptionStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                        <select value={leftPanel.descriptionStyle.fontSize} onChange={(e) => updatePanelStyle(setLeftPanel, 'descriptionStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="text-base">Base</option>
                          <option value="text-lg">Large</option>
                        </select>
                        <select value={leftPanel.descriptionStyle.fontWeight} onChange={(e) => updatePanelStyle(setLeftPanel, 'descriptionStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={leftPanel.descriptionStyle.fontFamily} onChange={(e) => updatePanelStyle(setLeftPanel, 'descriptionStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-sm">CTA Styling</h4>
                        <input type="text" value={leftPanel.ctaStyle.bgColor} onChange={(e) => updatePanelStyle(setLeftPanel, 'ctaStyle', 'bgColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="bg-white" />
                        <input type="text" value={leftPanel.ctaStyle.textColor} onChange={(e) => updatePanelStyle(setLeftPanel, 'ctaStyle', 'textColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="text-gray-900" />
                      </div>
                    </div>
                  </details>
                )}

                <div className="grid grid-cols-2 gap-4">
                  <details open>
                    <summary className="font-medium text-sm cursor-pointer">Right Top Panel</summary>
                    <div className="mt-2 space-y-3">
                      <input value={rightTopPanel.title} onChange={(e) => updatePanel(setRightTopPanel, 'title', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Title" />
                      <input value={rightTopPanel.subtitle} onChange={(e) => updatePanel(setRightTopPanel, 'subtitle', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Subtitle" />
                      <textarea value={rightTopPanel.description} onChange={(e) => updatePanel(setRightTopPanel, 'description', e.target.value)} className="w-full px-2 py-1 border rounded text-sm h-16" placeholder="Description" />
                      <input value={rightTopPanel.ctaText} onChange={(e) => updatePanel(setRightTopPanel, 'ctaText', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="CTA Text" />
                      <input value={rightTopPanel.ctaLink} onChange={(e) => updatePanel(setRightTopPanel, 'ctaLink', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="CTA Link" />
                      <input value={rightTopPanel.bgClass} onChange={(e) => updatePanel(setRightTopPanel, 'bgClass', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Bg class or gradient" />
                      <div>
                        <label className="block text-xs font-medium mb-1">Background Image</label>
                        <input type="file" accept="image/*" onChange={(e) => handleImageUpload(null, e, setRightTopPanel, true, null)} className="text-xs" />
                        {rightTopPanel.image && <img src={rightTopPanel.image} alt="preview" className="mt-3 h-20 w-full object-cover rounded" />}
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Image Overlay</h4>
                        <input type="text" value={rightTopPanel.imageOverlayColor} onChange={(e) => updatePanel(setRightTopPanel, 'imageOverlayColor', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="black" />
                        <input type="number" value={rightTopPanel.imageOverlayOpacity} onChange={(e) => updatePanel(setRightTopPanel, 'imageOverlayOpacity', parseInt(e.target.value) || 20)} min="0" max="100" className="w-full px-2 py-1 border rounded text-sm" placeholder="Opacity 0-100" />
                      </div>
                      <input value={rightTopPanel.contentPadding} onChange={(e) => updatePanel(setRightTopPanel, 'contentPadding', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Content Padding e.g. p-8" />
                      {/* Add styling inputs similar to leftPanel */}
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Title Styling</h4>
                        <input type="color" value={rightTopPanel.titleStyle.color} onChange={(e) => updatePanelStyle(setRightTopPanel, 'titleStyle', 'color', e.target.value)} className="h-8 w-full rounded border" />
                        <select value={rightTopPanel.titleStyle.fontSize} onChange={(e) => updatePanelStyle(setRightTopPanel, 'titleStyle', 'fontSize', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="text-xl">XL</option>
                          <option value="text-2xl">2XL</option>
                        </select>
                        <select value={rightTopPanel.titleStyle.fontWeight} onChange={(e) => updatePanelStyle(setRightTopPanel, 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-medium">Medium</option>
                          <option value="font-bold">Bold</option>
                        </select>
                        <select value={rightTopPanel.titleStyle.fontFamily} onChange={(e) => updatePanelStyle(setRightTopPanel, 'titleStyle', 'fontFamily', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Subtitle Styling</h4>
                        <input type="color" value={rightTopPanel.subtitleStyle.color} onChange={(e) => updatePanelStyle(setRightTopPanel, 'subtitleStyle', 'color', e.target.value)} className="h-8 w-full rounded border" />
                        <select value={rightTopPanel.subtitleStyle.fontSize} onChange={(e) => updatePanelStyle(setRightTopPanel, 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="text-sm">Small</option>
                          <option value="text-base">Base</option>
                        </select>
                        <select value={rightTopPanel.subtitleStyle.fontWeight} onChange={(e) => updatePanelStyle(setRightTopPanel, 'subtitleStyle', 'fontWeight', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={rightTopPanel.subtitleStyle.fontFamily} onChange={(e) => updatePanelStyle(setRightTopPanel, 'subtitleStyle', 'fontFamily', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Description Styling</h4>
                        <input type="color" value={rightTopPanel.descriptionStyle.color} onChange={(e) => updatePanelStyle(setRightTopPanel, 'descriptionStyle', 'color', e.target.value)} className="h-8 w-full rounded border" />
                        <select value={rightTopPanel.descriptionStyle.fontSize} onChange={(e) => updatePanelStyle(setRightTopPanel, 'descriptionStyle', 'fontSize', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="text-base">Base</option>
                          <option value="text-lg">Large</option>
                        </select>
                        <select value={rightTopPanel.descriptionStyle.fontWeight} onChange={(e) => updatePanelStyle(setRightTopPanel, 'descriptionStyle', 'fontWeight', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={rightTopPanel.descriptionStyle.fontFamily} onChange={(e) => updatePanelStyle(setRightTopPanel, 'descriptionStyle', 'fontFamily', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">CTA Styling</h4>
                        <input type="text" value={rightTopPanel.ctaStyle.bgColor} onChange={(e) => updatePanelStyle(setRightTopPanel, 'ctaStyle', 'bgColor', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="bg-transparent" />
                        <input type="text" value={rightTopPanel.ctaStyle.textColor} onChange={(e) => updatePanelStyle(setRightTopPanel, 'ctaStyle', 'textColor', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="text-gray-900 underline" />
                      </div>
                    </div>
                  </details>
                  <details open>
                    <summary className="font-medium text-sm cursor-pointer">Right Bottom Panel</summary>
                    <div className="mt-2 space-y-3">
                      <input value={rightBottomPanel.title} onChange={(e) => updatePanel(setRightBottomPanel, 'title', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Title" />
                      <input value={rightBottomPanel.subtitle} onChange={(e) => updatePanel(setRightBottomPanel, 'subtitle', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Subtitle" />
                      <textarea value={rightBottomPanel.description} onChange={(e) => updatePanel(setRightBottomPanel, 'description', e.target.value)} className="w-full px-2 py-1 border rounded text-sm h-16" placeholder="Description" />
                      <input value={rightBottomPanel.ctaText} onChange={(e) => updatePanel(setRightBottomPanel, 'ctaText', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="CTA Text" />
                      <input value={rightBottomPanel.ctaLink} onChange={(e) => updatePanel(setRightBottomPanel, 'ctaLink', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="CTA Link" />
                      <input value={rightBottomPanel.bgClass} onChange={(e) => updatePanel(setRightBottomPanel, 'bgClass', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Bg class or gradient" />
                      <div>
                        <label className="block text-xs font-medium mb-1">Background Image</label>
                        <input type="file" accept="image/*" onChange={(e) => handleImageUpload(null, e, setRightBottomPanel, true, null)} className="text-xs" />
                        {rightBottomPanel.image && <img src={rightBottomPanel.image} alt="preview" className="mt-3 h-20 w-full object-cover rounded" />}
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Image Overlay</h4>
                        <input type="text" value={rightBottomPanel.imageOverlayColor} onChange={(e) => updatePanel(setRightBottomPanel, 'imageOverlayColor', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="black" />
                        <input type="number" value={rightBottomPanel.imageOverlayOpacity} onChange={(e) => updatePanel(setRightBottomPanel, 'imageOverlayOpacity', parseInt(e.target.value) || 20)} min="0" max="100" className="w-full px-2 py-1 border rounded text-sm" placeholder="Opacity 0-100" />
                      </div>
                      <input value={rightBottomPanel.contentPadding} onChange={(e) => updatePanel(setRightBottomPanel, 'contentPadding', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="Content Padding e.g. p-8" />
                      {/* Similar styling inputs as above */}
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Title Styling</h4>
                        <input type="color" value={rightBottomPanel.titleStyle.color} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'titleStyle', 'color', e.target.value)} className="h-8 w-full rounded border" />
                        <select value={rightBottomPanel.titleStyle.fontSize} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'titleStyle', 'fontSize', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="text-xl">XL</option>
                          <option value="text-2xl">2XL</option>
                        </select>
                        <select value={rightBottomPanel.titleStyle.fontWeight} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-medium">Medium</option>
                          <option value="font-bold">Bold</option>
                        </select>
                        <select value={rightBottomPanel.titleStyle.fontFamily} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'titleStyle', 'fontFamily', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Subtitle Styling</h4>
                        <input type="color" value={rightBottomPanel.subtitleStyle.color} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'subtitleStyle', 'color', e.target.value)} className="h-8 w-full rounded border" />
                        <select value={rightBottomPanel.subtitleStyle.fontSize} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="text-sm">Small</option>
                          <option value="text-base">Base</option>
                        </select>
                        <select value={rightBottomPanel.subtitleStyle.fontWeight} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'subtitleStyle', 'fontWeight', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={rightBottomPanel.subtitleStyle.fontFamily} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'subtitleStyle', 'fontFamily', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">Description Styling</h4>
                        <input type="color" value={rightBottomPanel.descriptionStyle.color} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'descriptionStyle', 'color', e.target.value)} className="h-8 w-full rounded border" />
                        <select value={rightBottomPanel.descriptionStyle.fontSize} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'descriptionStyle', 'fontSize', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="text-base">Base</option>
                          <option value="text-lg">Large</option>
                        </select>
                        <select value={rightBottomPanel.descriptionStyle.fontWeight} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'descriptionStyle', 'fontWeight', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-normal">Normal</option>
                          <option value="font-medium">Medium</option>
                        </select>
                        <select value={rightBottomPanel.descriptionStyle.fontFamily} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'descriptionStyle', 'fontFamily', e.target.value)} className="w-full px-2 py-1 border rounded text-sm">
                          <option value="font-sans">Sans</option>
                          <option value="font-serif">Serif</option>
                          <option value="font-mono">Mono</option>
                        </select>
                      </div>
                      <div className="space-y-3">
                        <h4 className="font-medium text-xs">CTA Styling</h4>
                        <input type="text" value={rightBottomPanel.ctaStyle.bgColor} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'ctaStyle', 'bgColor', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="bg-transparent" />
                        <input type="text" value={rightBottomPanel.ctaStyle.textColor} onChange={(e) => updatePanelStyle(setRightBottomPanel, 'ctaStyle', 'textColor', e.target.value)} className="w-full px-2 py-1 border rounded text-sm" placeholder="text-gray-900 underline" />
                      </div>
                    </div>
                  </details>
                </div>

                {bannerpreset === 'asymmetric' && (
                  <div className="space-y-4">
                    <details open>
                      <summary className="font-medium cursor-pointer">Sidebar Top</summary>
                      <div className="mt-2 space-y-3">
                        <input value={asymmetricSidebar.top.title} onChange={(e) => updateAsymmetric('top', 'title', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Title" />
                        <input value={asymmetricSidebar.top.subtitle} onChange={(e) => updateAsymmetric('top', 'subtitle', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Subtitle" />
                        <textarea value={asymmetricSidebar.top.description} onChange={(e) => updateAsymmetric('top', 'description', e.target.value)} className="w-full px-3 py-2 border rounded-md h-16" placeholder="Description" />
                        <input value={asymmetricSidebar.top.ctaText} onChange={(e) => updateAsymmetric('top', 'ctaText', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="CTA Text" />
                        <input value={asymmetricSidebar.top.ctaLink} onChange={(e) => updateAsymmetric('top', 'ctaLink', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="CTA Link" />
                        <input value={asymmetricSidebar.top.bgClass} onChange={(e) => updateAsymmetric('top', 'bgClass', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Bg class or gradient" />
                        <div>
                          <label className="block text-sm font-medium mb-1">Background Image</label>
                          <input type="file" accept="image/*" onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = () => updateAsymmetric('top', 'image', reader.result);
                              reader.readAsDataURL(file);
                            }
                          }} className="text-sm" />
                          {asymmetricSidebar.top.image && <img src={asymmetricSidebar.top.image} alt="preview" className="mt-3 h-40 w-full object-cover rounded" />}
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Image Overlay</h4>
                          <input type="text" value={asymmetricSidebar.top.imageOverlayColor} onChange={(e) => updateAsymmetric('top', 'imageOverlayColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="black" />
                          <input type="number" value={asymmetricSidebar.top.imageOverlayOpacity} onChange={(e) => updateAsymmetric('top', 'imageOverlayOpacity', parseInt(e.target.value) || 20)} min="0" max="100" className="w-full px-3 py-2 border rounded-md" placeholder="Opacity 0-100" />
                        </div>
                        <input value={asymmetricSidebar.top.contentPadding} onChange={(e) => updateAsymmetric('top', 'contentPadding', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Content Padding e.g. p-8" />
                        {/* Styling inputs */}
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Title Styling</h4>
                          <input type="color" value={asymmetricSidebar.top.titleStyle.color} onChange={(e) => updateAsymmetricStyle('top', 'titleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                          <select value={asymmetricSidebar.top.titleStyle.fontSize} onChange={(e) => updateAsymmetricStyle('top', 'titleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="text-xl">XL</option>
                            <option value="text-2xl">2XL</option>
                          </select>
                          <select value={asymmetricSidebar.top.titleStyle.fontWeight} onChange={(e) => updateAsymmetricStyle('top', 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-medium">Medium</option>
                            <option value="font-bold">Bold</option>
                          </select>
                          <select value={asymmetricSidebar.top.titleStyle.fontFamily} onChange={(e) => updateAsymmetricStyle('top', 'titleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-sans">Sans</option>
                            <option value="font-serif">Serif</option>
                            <option value="font-mono">Mono</option>
                          </select>
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Subtitle Styling</h4>
                          <input type="color" value={asymmetricSidebar.top.subtitleStyle.color} onChange={(e) => updateAsymmetricStyle('top', 'subtitleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                          <select value={asymmetricSidebar.top.subtitleStyle.fontSize} onChange={(e) => updateAsymmetricStyle('top', 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="text-sm">Small</option>
                            <option value="text-base">Base</option>
                          </select>
                          <select value={asymmetricSidebar.top.subtitleStyle.fontWeight} onChange={(e) => updateAsymmetricStyle('top', 'subtitleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-normal">Normal</option>
                            <option value="font-medium">Medium</option>
                          </select>
                          <select value={asymmetricSidebar.top.subtitleStyle.fontFamily} onChange={(e) => updateAsymmetricStyle('top', 'subtitleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-sans">Sans</option>
                            <option value="font-serif">Serif</option>
                            <option value="font-mono">Mono</option>
                          </select>
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Description Styling</h4>
                          <input type="color" value={asymmetricSidebar.top.descriptionStyle.color} onChange={(e) => updateAsymmetricStyle('top', 'descriptionStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                          <select value={asymmetricSidebar.top.descriptionStyle.fontSize} onChange={(e) => updateAsymmetricStyle('top', 'descriptionStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="text-base">Base</option>
                            <option value="text-lg">Large</option>
                          </select>
                          <select value={asymmetricSidebar.top.descriptionStyle.fontWeight} onChange={(e) => updateAsymmetricStyle('top', 'descriptionStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-normal">Normal</option>
                            <option value="font-medium">Medium</option>
                          </select>
                          <select value={asymmetricSidebar.top.descriptionStyle.fontFamily} onChange={(e) => updateAsymmetricStyle('top', 'descriptionStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-sans">Sans</option>
                            <option value="font-serif">Serif</option>
                            <option value="font-mono">Mono</option>
                          </select>
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">CTA Styling</h4>
                          <input type="text" value={asymmetricSidebar.top.ctaStyle.bgColor} onChange={(e) => updateAsymmetricStyle('top', 'ctaStyle', 'bgColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="bg-white" />
                          <input type="text" value={asymmetricSidebar.top.ctaStyle.textColor} onChange={(e) => updateAsymmetricStyle('top', 'ctaStyle', 'textColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="text-gray-900" />
                        </div>
                      </div>
                    </details>
                    <details open>
                      <summary className="font-medium cursor-pointer">Sidebar Bottom</summary>
                      <div className="mt-2 space-y-3">
                        <input value={asymmetricSidebar.bottom.title} onChange={(e) => updateAsymmetric('bottom', 'title', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Title" />
                        <input value={asymmetricSidebar.bottom.subtitle} onChange={(e) => updateAsymmetric('bottom', 'subtitle', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Subtitle" />
                        <textarea value={asymmetricSidebar.bottom.description} onChange={(e) => updateAsymmetric('bottom', 'description', e.target.value)} className="w-full px-3 py-2 border rounded-md h-16" placeholder="Description" />
                        <input value={asymmetricSidebar.bottom.ctaText} onChange={(e) => updateAsymmetric('bottom', 'ctaText', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="CTA Text" />
                        <input value={asymmetricSidebar.bottom.ctaLink} onChange={(e) => updateAsymmetric('bottom', 'ctaLink', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="CTA Link" />
                        <input value={asymmetricSidebar.bottom.bgClass} onChange={(e) => updateAsymmetric('bottom', 'bgClass', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Bg class or gradient" />
                        <div>
                          <label className="block text-sm font-medium mb-1">Background Image</label>
                          <input type="file" accept="image/*" onChange={(e) => {
                            const file = e.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = () => updateAsymmetric('bottom', 'image', reader.result);
                              reader.readAsDataURL(file);
                            }
                          }} className="text-sm" />
                          {asymmetricSidebar.bottom.image && <img src={asymmetricSidebar.bottom.image} alt="preview" className="mt-3 h-40 w-full object-cover rounded" />}
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Image Overlay</h4>
                          <input type="text" value={asymmetricSidebar.bottom.imageOverlayColor} onChange={(e) => updateAsymmetric('bottom', 'imageOverlayColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="black" />
                          <input type="number" value={asymmetricSidebar.bottom.imageOverlayOpacity} onChange={(e) => updateAsymmetric('bottom', 'imageOverlayOpacity', parseInt(e.target.value) || 20)} min="0" max="100" className="w-full px-3 py-2 border rounded-md" placeholder="Opacity 0-100" />
                        </div>
                        <input value={asymmetricSidebar.bottom.contentPadding} onChange={(e) => updateAsymmetric('bottom', 'contentPadding', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="Content Padding e.g. p-8" />
                        {/* Styling inputs */}
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Title Styling</h4>
                          <input type="color" value={asymmetricSidebar.bottom.titleStyle.color} onChange={(e) => updateAsymmetricStyle('bottom', 'titleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                          <select value={asymmetricSidebar.bottom.titleStyle.fontSize} onChange={(e) => updateAsymmetricStyle('bottom', 'titleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="text-xl">XL</option>
                            <option value="text-2xl">2XL</option>
                          </select>
                          <select value={asymmetricSidebar.bottom.titleStyle.fontWeight} onChange={(e) => updateAsymmetricStyle('bottom', 'titleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-medium">Medium</option>
                            <option value="font-bold">Bold</option>
                          </select>
                          <select value={asymmetricSidebar.bottom.titleStyle.fontFamily} onChange={(e) => updateAsymmetricStyle('bottom', 'titleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-sans">Sans</option>
                            <option value="font-serif">Serif</option>
                            <option value="font-mono">Mono</option>
                          </select>
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Subtitle Styling</h4>
                          <input type="color" value={asymmetricSidebar.bottom.subtitleStyle.color} onChange={(e) => updateAsymmetricStyle('bottom', 'subtitleStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                          <select value={asymmetricSidebar.bottom.subtitleStyle.fontSize} onChange={(e) => updateAsymmetricStyle('bottom', 'subtitleStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="text-sm">Small</option>
                            <option value="text-base">Base</option>
                          </select>
                          <select value={asymmetricSidebar.bottom.subtitleStyle.fontWeight} onChange={(e) => updateAsymmetricStyle('bottom', 'subtitleStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-normal">Normal</option>
                            <option value="font-medium">Medium</option>
                          </select>
                          <select value={asymmetricSidebar.bottom.subtitleStyle.fontFamily} onChange={(e) => updateAsymmetricStyle('bottom', 'subtitleStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-sans">Sans</option>
                            <option value="font-serif">Serif</option>
                            <option value="font-mono">Mono</option>
                          </select>
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">Description Styling</h4>
                          <input type="color" value={asymmetricSidebar.bottom.descriptionStyle.color} onChange={(e) => updateAsymmetricStyle('bottom', 'descriptionStyle', 'color', e.target.value)} className="h-10 w-full rounded border" />
                          <select value={asymmetricSidebar.bottom.descriptionStyle.fontSize} onChange={(e) => updateAsymmetricStyle('bottom', 'descriptionStyle', 'fontSize', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="text-base">Base</option>
                            <option value="text-lg">Large</option>
                          </select>
                          <select value={asymmetricSidebar.bottom.descriptionStyle.fontWeight} onChange={(e) => updateAsymmetricStyle('bottom', 'descriptionStyle', 'fontWeight', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-normal">Normal</option>
                            <option value="font-medium">Medium</option>
                          </select>
                          <select value={asymmetricSidebar.bottom.descriptionStyle.fontFamily} onChange={(e) => updateAsymmetricStyle('bottom', 'descriptionStyle', 'fontFamily', e.target.value)} className="w-full px-3 py-2 border rounded-md">
                            <option value="font-sans">Sans</option>
                            <option value="font-serif">Serif</option>
                            <option value="font-mono">Mono</option>
                          </select>
                        </div>
                        <div className="space-y-3">
                          <h4 className="font-medium text-sm">CTA Styling</h4>
                          <input type="text" value={asymmetricSidebar.bottom.ctaStyle.bgColor} onChange={(e) => updateAsymmetricStyle('bottom', 'ctaStyle', 'bgColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="bg-gray-900" />
                          <input type="text" value={asymmetricSidebar.bottom.ctaStyle.textColor} onChange={(e) => updateAsymmetricStyle('bottom', 'ctaStyle', 'textColor', e.target.value)} className="w-full px-3 py-2 border rounded-md" placeholder="text-white" />
                        </div>
                      </div>
                    </details>
                  </div>
                )}
              </div>
            </details>
          )}

          <details className="bg-yellow-50 border border-yellow-200 rounded-xl p-5">
            <summary className="font-semibold text-yellow-900 cursor-pointer">Dev Mode</summary>
            <div className="mt-4 flex justify-between items-center">
              <h3 className="font-semibold text-yellow-900">Enabled</h3>
              <button onClick={() => setDevMode(!devMode)} className={`relative inline-flex h-6 w-11 rounded-full transform hover:scale-110 transition ${devMode ? 'bg-yellow-600' : 'bg-gray-300'}`}>
                <span className={`inline-block h-4 w-4 rounded-full bg-white transition ${devMode ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
            </div>
            {devMode && (
              <div className="mt-3 space-y-3">
                <input value={container.padding} onChange={(e) => setContainer({ ...container, padding: e.target.value })} className="w-full px-3 py-2 border rounded-md" placeholder="Padding (e.g. p-10)" />
                <input value={container.margin} onChange={(e) => setContainer({ ...container, margin: e.target.value })} className="w-full px-3 py-2 border rounded-md" placeholder="Margin" />
                <input value={container.borderRadius} onChange={(e) => setContainer({ ...container, borderRadius: e.target.value })} className="w-full px-3 py-2 border rounded-md" placeholder="Border Radius" />
                <input value={container.boxShadow} onChange={(e) => setContainer({ ...container, boxShadow: e.target.value })} className="w-full px-3 py-2 border rounded-md" placeholder="Box Shadow" />
              </div>
            )}
          </details>
        </div>

        {/* Fixed Save Button */}
        <div className="fixed bottom-0 right-0 w-96 bg-white border-t p-6 shadow-lg">
          <button
            onClick={saveBannerSettings}
            disabled={saving}
            className="w-full bg-blue-600 text-white py-4 rounded-xl font-bold hover:bg-blue-700 disabled:opacity-70 shadow transform hover:scale-105 active:scale-95 transition"
          >
            {saving ? 'Saving...' : 'Save & Publish Banner'}
          </button>
        </div>
      </div>

      {/* Full Screen Modal */}
      {fullScreenPreview && (
        <div className="fixed inset-0 bg-black/95 z-50 flex flex-col" onClick={() => setFullScreenPreview(false)}>
          <div className="bg-white/10 backdrop-blur px-6 py-4 flex justify-end">
            <button className="text-white text-4xl hover:text-gray-300 transform hover:scale-110 transition">&times;</button>
          </div>
          <div className="flex-1 overflow-auto" onClick={(e) => e.stopPropagation()}>
            <div className={container.padding}>
              <Banner config={currentConfig} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BannerAdmin;